import { useEffect, useState, useMemo } from "react";
import {
  getPackageCategories,
  getPackageTypes,
  getPartnerTypes,
} from "../../../apis";

import HeaderStep from "../../../Pages/AddOrEditPartner/PartnerSteps/HeaderStep";
import DropdownForm from "../../Form/DropdownForm";
import FormField from "../../Form/FormField";
import TextareaForm from "../../Form/TextareaForm";

const PackageStepOne = ({
  errors,
  touched,
  handleBlur,
  setFieldValue,
  handleChange,
  values,
}) => {
  const [packageCategories, setPackageCategories] = useState([]);
  const [partnerTypes, setPartnerTypes] = useState([]);
  const [packageTypes, setPackageTypes] = useState([]);

  // Fetch Data Once When Component Mounts
  useEffect(() => {
    const fetchData = async () => {
      try {
        const [categoriesRes, partnersRes, typesRes] = await Promise.all([
          getPackageCategories(),
          getPartnerTypes(),
          getPackageTypes(),
        ]);

        setPackageCategories(categoriesRes.data.data || []);
        setPartnerTypes(partnersRes.data.data || []);
        setPackageTypes(typesRes.data.data || []);
      } catch (err) {
        console.error("Error fetching data:", err);
      }
    };

    fetchData();
  }, []);

  // Ensure `courses` field has the correct number of entries
  useEffect(() => {
    setFieldValue(
      "courses",
      Array.from({ length: Number(values.no_of_courses) || 1 }, () => ({
        course_name: "",
        course_price: "0",
        pv_upliner: "0",
      }))
    );
  }, [values.no_of_courses, setFieldValue]);

  // Transform `packageTypes` into expected format only when it changes
  const transformedPackageTypes = useMemo(
    () =>
      packageTypes.map((item) => ({
        id: item,
        title: item,
      })),
    [packageTypes]
  );

  return (
    <div className="card !tw-rounded-xl">
      <div className="tw-rounded-t-xl tw-overflow-hidden">
        <HeaderStep stepNumber={1} stepName="Basic Data" stepText="Part" />
      </div>

      <div className="card-body tw-shadow-xl tw-rounded-xl">
        <div className="row">
          {/* Package Category */}
          <DropdownForm
            handleChange={handleChange}
            name="package_category"
            dataToDrop={packageCategories}
            error={errors.package_category}
            touched={touched.package_category}
            label="Package Category"
            placeholder="Package Category"
            labelKey="name_en"
            gridStyle="col-sm-6"
          />

          {/* Assigned To */}
          <DropdownForm
            handleChange={handleChange}
            name="assigned_to"
            dataToDrop={partnerTypes}
            error={errors.assigned_to}
            touched={touched.assigned_to}
            label="Assigned To"
            placeholder="Assigned To"
            labelKey="name_en"
            gridStyle="col-sm-6"
          />

          {/* Package Type */}
          <DropdownForm
            handleChange={handleChange}
            name="package_type"
            dataToDrop={transformedPackageTypes}
            error={errors.package_type}
            touched={touched.package_type}
            label="Package Type"
            placeholder="Package Type"
            gridStyle="col-sm-6"
          />

          {/* Number of Courses */}
          <DropdownForm
            handleChange={handleChange}
            name="no_of_courses"
            dataToDrop={Array.from({ length: 10 }, (_, i) => ({
              id: i + 1,
              title: i + 1,
            }))}
            error={errors.no_of_courses}
            touched={touched.no_of_courses}
            label="No Of Courses"
            placeholder="No Of Courses"
            gridStyle="col-sm-6"
          />

          {/* Package Title English */}
          <FormField
            name="package_title_english"
            label="Package Title English"
            placeholder="Package Title English"
            touched={touched}
            errors={errors}
            col_md="6"
            handleBlur={handleBlur}
            handleChange={handleChange}
            setFieldValue={setFieldValue}
            value={values.package_title_english}
          />

          {/* Package Title Arabic */}
          <FormField
            name="package_title_arabic"
            label="Package Title Arabic"
            placeholder="Package Title Arabic"
            touched={touched}
            errors={errors}
            col_md="6"
            handleBlur={handleBlur}
            handleChange={handleChange}
            setFieldValue={setFieldValue}
            value={values.package_title_arabic}
          />

          {/* Package Description English */}
          <TextareaForm
            name="package_description_english"
            placeholder="Package Description English"
            touched={touched.package_description_english}
            errors={errors.package_description_english}
            handleBlur={handleBlur}
            label="Package Description English"
          />

          {/* Package Description Arabic */}
          <TextareaForm
            name="package_description_arabic"
            placeholder="Package Description Arabic"
            touched={touched.package_description_arabic}
            errors={errors.package_description_arabic}
            handleBlur={handleBlur}
            label="Package Description Arabic"
          />
        </div>
      </div>
    </div>
  );
};

export default PackageStepOne;
